export default __webpack_public_path__ + "static/media/masterpro-service-contractors-image.2015ac94.jpg";